<script>
  import LoadingIndicator from "$lib/components/LoadingIndicator.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import { onMount } from "svelte";

  let clazz = "";
  export { clazz as class };

  export let data;
  export let fullWidth = false;

  onMount(() => {
    window.twttr && window.twttr.widgets.load();
  });
</script>

<svelte:head>
  <script
    async={true}
    defer={false}
    src="https://platform.twitter.com/widgets.js"
    charset="utf-8"
  ></script>
</svelte:head>

<Bleed {fullWidth} class={clazz}>
  <div class="max-sm:w-[320px] w-[350px] md:w-380 lg:w-360 -my-10 mx-auto" data-chromatic="ignore">
    <blockquote class="twitter-tweet">
      <a class="twitter-tweet" href={data.fields.url}>
        <LoadingIndicator
          containerClasses="justify-center"
          spinnerClasses="w-[2rem] h-[2rem]"
          screenreaderText="Loading a tweet"
        />
      </a>
    </blockquote>
  </div>
</Bleed>
